import customConnect from '../customConnect.js';
import {map} from './map';
import {panZoom} from './actions';

var movvendEventHandler = null;
map.on('moveend', (ev) => {

	if(typeof ev === 'undefined') {
		return;
	}

	var view = map.getView();

	if(typeof movvendEventHandler === 'function') {
		movvendEventHandler({coords: view.getCenter(), zoom: parseInt(view.getZoom())});
	}
	
});

var stateUpdateHandler = function(props) {

	if(props.updateSource == 'URL') {
		var view = map.getView();
	//	
		view.setCenter(props.coords);
		view.setZoom(parseInt(props.zoom));
	}
	

	movvendEventHandler = props.panzoom;
};

export default function (store) { //new props and action function


	const mapStateToPropsRes = (state) => {

		return {
			coords: state.map.coords,
			zoom: parseInt(state.map.zoom),
			updateSource: state.map.updateSource
		};
	};

	const mapDispatchToPropsRes = (dispatch) => {

		return {panzoom: (data) => {
			data.updateSource = 'UI';
			dispatch(panZoom(data));
		}};
	};

	customConnect(mapStateToPropsRes, mapDispatchToPropsRes, store, stateUpdateHandler);
}